import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PharmacyApiConfiguration } from '../apiConfiguration';
import { ServiceBase } from 'app/shared/infrastructure';

@Injectable()
export class DoctorQuickPrescriptionDetailService extends ServiceBase {
    private _getUrl: string;
    private _addUrl: string;
    private _updateUrl: string;
    private _deleteUrl: string;

    constructor(
        private _http: HttpClient,
        private _configuration: PharmacyApiConfiguration
    ) {
        super();
        const base = _configuration.server;
        this._getUrl = base + _configuration.doctorQuickPrescriptionDetail.getByPrescriptionId;
        this._addUrl = base + _configuration.doctorQuickPrescriptionDetail.add;
        this._updateUrl = base + _configuration.doctorQuickPrescriptionDetail.update;
        this._deleteUrl = base + _configuration.doctorQuickPrescriptionDetail.delete;
    }

    getByPrescriptionId(id: number): Observable<any[]> {
        return this._http.get<any[]>(`${this._getUrl}?prescriptionId=${id}`);
    }

    add(prescriptionId: number, drug: any): Observable<any> {
        return this._http.post(`${this._addUrl}/${prescriptionId}`, drug);
    }

    update(detailId: number, drug: any): Observable<any> {
        return this._http.put(`${this._updateUrl}/${detailId}`, drug);
    }

    delete(detailId: number): Observable<any> {
        return this._http.delete(`${this._deleteUrl}/${detailId}`);
    }
}